import {useQueryClient} from "@tanstack/react-query";
import {track} from "analytics";
import {guestSession, sendLoginCode, verifyLoginCode} from "api/guest.api";
import {useAuth} from "context/AuthContext";

/**
 * Log in to an existing account with the 4-digit SMS code (sent to the phone
 * confirmed on the account). Used by the Log in window and the booking popup.
 * Both calls throw API errors (use guestErrorCode / guestErrorMessage).
 */
export const useCodeLogin = (source) => {
    const {loginWithCustomToken} = useAuth();
    const queryClient = useQueryClient();

    // Returns the last 4 digits of the phone the code was sent to.
    const sendCode = async (identifier, turnstileToken) => {
        const data = await sendLoginCode({identifier: identifier.trim(), turnstile_token: turnstileToken});
        track("code_login_sent", {source});
        return data?.phone_last4 || "";
    };

    const verify = async (identifier, code) => {
        const data = await verifyLoginCode({identifier: identifier.trim(), code});
        await loginWithCustomToken({firebaseToken: data.token_firebase, appToken: data.token});
        guestSession.clear();
        queryClient.invalidateQueries();
        track("code_login_verified", {source});
        return data;
    };

    return {sendCode, verify};
};
